const stickySummary = (Simplebar) => {
    const stickyWrap = document.querySelector(".order__wrapper.right");
    if (stickyWrap) {
        const scrollWrap = stickyWrap.querySelector(".order__summary-scroll");
        let simple;
        if (scrollWrap) {
            simple = new Simplebar(scrollWrap, {autoHidden: false});
        }
        function setScrollWrap() {
            stickyWrap.classList.remove("scroll");
            let wrapHeight = stickyWrap.getBoundingClientRect().height;
            if (wrapHeight > window.innerHeight - 30) {
                stickyWrap.classList.add("scroll");
            }
            else {
                stickyWrap.classList.remove("scroll");
                simple.scrollY(0);
            }
        }
        setScrollWrap();
        window.addEventListener("load", setScrollWrap, {once: true});
        window.addEventListener("resize", setScrollWrap);

        const observer = new MutationObserver(setScrollWrap);
        observer.observe(stickyWrap, {attributes: false, childList: true, subtree: true});
    }
}
export default stickySummary;